/* eslint-disable react/display-name */
/**
 *
 * FormularioPreguntas
 *
 */

import { memo } from 'react';

import { lazyLoad } from 'utils/loadable';

import { StatementRouting } from './statement.routing';
interface Props {}

export const StatementComponent = memo((props: Props) => {
  return (
    <>
      <div></div>
      <StatementRouting />
    </>
  );
});

export const StatementModule = lazyLoad(
  () => import('./statement.module'),
  (module) => module.StatementComponent
);
